import { DateTime } from "luxon";
import { pluralize } from "./index";
import { LAND_USE } from "../configs/constants";

const timeUnits = {
	SECOND: 1000,
	MINUTE: 6e4,
	HOUR: 36e5,
	DAY: 864e5,
	WEEK: 6048e5,
};

export const fallbackRelativeDate = (dt, now) =>
  dt.toFormat("dd MMM") + (dt.year === now.year ? "" : `, ${dt.year}`);

export const getRelativeCalendarPastYesterday = (dtIso, now) => {
  for (let i = 2; i <= 7; i++) {
    // works for 2 days - 7 days
    if (dtIso === now.minus({ days: i }).toISODate()) return `${i} days ago`;
  }

  return "";
};

export const relativeTime = (now, relativeDate) => {
  const diff = now.ts - relativeDate.ts;
  if (diff <= 0) return "";
  const units = {
    hours: Math.round(diff / timeUnits.HOUR),
    minutes: Math.round(diff / timeUnits.MINUTE),
    seconds: Math.round(diff / timeUnits.SECOND),
  };

  if (units.seconds === 0) return "Just now";
  if (diff < timeUnits.MINUTE) return `${pluralize(units.seconds, "second")} ago`;
  if (diff < timeUnits.HOUR) return `${pluralize(units.minutes, "minute")} ago`;
  return `${pluralize(units.hours, "hour")} ago`;
};

export const ISO_8601_FULL =
  /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

export const relativeDate = (dateTime, opts) => {
  if (!dateTime) return "";
  const now = DateTime.local().setLocale("en-EN").setZone("America/Chicago");
  const dt = ISO_8601_FULL.test(dateTime) ?
    DateTime.fromISO(dateTime, {/* zone: opts.tz*/ }) :
    DateTime.fromSQL(dateTime);

  const dtIso = dt.toISODate();
  const friendlyTime = dt.toFormat("h:mma").toLowerCase();

  if (opts) {
    now.setZone(opts.tz);
  }

  if (dt <= now) {
    // date is in the past
    if (dtIso === now.toISODate()) return relativeTime(now, dt);
    if (dtIso === now.minus({ days: 1 }).toISODate()) { return `yesterday at ${friendlyTime}`; }
    if (dt > now.minus({ week: 1 })) { return getRelativeCalendarPastYesterday(dtIso, now); }

    return fallbackRelativeDate(dt, now);
  } // date is in the future

  if (dtIso === now.toISODate()) return `today at ${friendlyTime}`;
  if (dtIso === now.plus({ days: 1 }).toISODate()) { return `tomorrow at ${friendlyTime}`; }
  if (dtIso === now.plus({ days: 2 }).toISODate()) { return `in 2 days at ${friendlyTime}`; }
  if (dt <= now.plus({ week: 1 })) { return `${dt.toFormat("cccc")} at ${friendlyTime}`; }

  return `${fallbackRelativeDate(dt, now)} at ${friendlyTime}`;
};


export const formatCents = (value) => {
  if (typeof value !== "number") return;

  const parts = (value / 100).toFixed(2).split(".");
  const prefix = (value < 0) ? "- " : "";
  return `${prefix }$${ Math.abs(parts[0]).toLocaleString() }.${ parts[1]}`;
};

export const formatLandUse = (landUse) => LAND_USE[landUse];
